import { useTranslation } from 'react-i18next';

import styles from './History.module.scss';

const EmptyList = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.empty_list}>
      <h2 className={styles.empty_list__title}>
        {t('loyalty:progress:empty:title')}
      </h2>
      <p className={styles.empty_list__description}>
        {t('loyalty:progress:empty:description')}
      </p>
    </div>
  );
};

export default EmptyList;
